export { DialogModule } from './src/dialog.module';
export { DialogService } from './src/dialog.service';
